import React, { useState, useEffect } from "react";
import {Link, useHistory} from "react-router-dom";
import {postDogs, getTemperaments} from '../acctions/index';
import { useDispatch, useSelector} from 'react-redux';
import s from '../css/dogcreate.module.css';
import perritos from '../image/perritos.png'

function validate(input){
  let errorsx={};
  const onliLet=/^[a-zA-Z\s]*$/g.test(input.name)
  const numberHmin=/^[0-9\s]/g.test(input.height_Min)
  const numberHmax=/^[0-9\s]/g.test(input.height_Max)
  const numberWmin=/^[0-9\s]/g.test(input.weight_Min)
  const numberWmax=/^[0-9\s]/g.test(input.weight_Max)
  const numberLife=/^[0-9\s]/g.test(input.life_span)
  const minvalue=(input.name).length<3
  const gMinMayorMax= input.weight_Min > input.weight_Max
  const hMinMayorMax= input.height_Min > input.height_Max
  
  

  if( !input.name ) return errorsx.name = "Se requiere un Nombre";
  if(onliLet === false) return errorsx.name = "Los numeros no son aceptados en el Nombre"
  if(minvalue) return  errorsx.name=" Se requiere mas de 3 caracteres para un Nombre"

  if(!input.height_Min) return errorsx.height_Min = "Acompleta la Altura Minima";
  if(numberHmin===false) return errorsx.height_Min=" Solo se permiten Numeros"
  if(!input.height_Max)return errorsx.height_Max = "Acompleta la Altura Maxima";
  if(numberHmax===false) return errorsx.height_Max=" Solo se permiten Numeros"
  if(hMinMayorMax ) return errorsx.height_Max = "La Altura minima no puede ser Mayor que la Maxima: ¡¡Corrige!!"
  if(!input.weight_Min)return errorsx.weight_Min = "Acompleta el Peso Minimo";
  if(!input.weight_Max)return errorsx.weight_Max = "Acompleta el peso Maximo"; 
  if(numberWmin===false) return errorsx.weight_Min=" Solo se permiten Numeros"
  if(numberWmax===false) return errorsx.weight_Max=" Solo se permiten Numeros"
  if(gMinMayorMax ) return errorsx.weight_Max = "El Peso minimo no puede ser Mayor que el Maximo: ¡¡Corrige!!"
  if(!input.life_span) return errorsx.life_span= "Acompleta los años de vida"
  if(numberLife===false) return errorsx.life_span= "solo se permiten Numeros "
  
};


export default function  DogsCreate(){
  const dispatch = useDispatch()          //traeme el state.occupations
  const history = useHistory()
  const temperaments = useSelector((state)=> state.temperaments)
  
  //crear un formulario  y lo guardamos en un estado llamado input, y setinput
  const [input,setInput]= useState({
    name:"",
    height_Min:"",
    height_Max:"",
    weight_Min:"",
    weight_Max:"",
    life_span:"",
    image:"",
    temperaments:[]
  })

  function handleSelect(e){
    if(input.temperaments.includes(e.target.value)){
      alert('Temperamento ya seleccionado')
    }else {
        setInput({
            ...input,
            temperaments: [...input.temperaments, e.target.value]
        }) 
    }
  }

 //creamos estado local de errors,
 const [errors, setErrors] = useState({});

 const errorMessage= validate(input)

  const handleChange=(e)=> {
  
  setInput({
      ...input,
      [e.target.name]: e.target.value
    })
    //seteando los errores
    setErrors(validate({
    ...input,
    [e.target.name]: e.target.value,
    }));
  }

  function handleSubmit(e){
    e.preventDefault();
    dispatch(postDogs(input))
    alert("Breed created!!")
    setInput({
      name:"",
      height_Min:"",
      height_Max:"",
      weight_Min:"",
      weight_Max:"",
      life_span:"",
      image:"",
      temperaments:[]
    })
        history.push('/home')
  }

  function handleDelete(el){
    setInput({
      ...input,
      temperaments: input.temperaments.filter(temp => temp !== el)
    })
  }

     
  useEffect (()=> {
    dispatch(getTemperaments());
  },[dispatch]);   

  //hacemos el render
  return(
    <div className={s.contenedor}>
        
          <div >
          <Link to= '/home'><button className={s.btn3}>Return</button></Link>
          <img className={s.perritos} src={perritos} />
          <h2>Create Your New Breed</h2>
          <img className={s.perritos2} src={perritos} />
          </div>
          <form className={s.conten2} onSubmit={(e)=> handleSubmit(e)}>
            <div className={s.divf1}>
               <label>Breed *</label>   
               <input placeholder="Breed Name..." type="text" value= {input.name} name= "name"  required onChange={handleChange}/>
            </div>
            <div>
               <ul className={s.ul}>
                  <li className={s.li}><label>height *</label></li>
                  <li className={s.li}><input placeholder="Cm Min" className={s.input1} type="text" value={input.height_Min} name= "height_Min" onChange={handleChange}/></li>
                  <li className={s.li}><label>height *</label></li>
                  <li className={s.li}><input placeholder="Cm Max" className={s.input1} type="text" value={input.height_Max} name= "height_Max" onChange={handleChange}/></li>      
               </ul>
            </div>
            <div>
               <ul className={s.ul}>
                  <li className={s.li}><label>weight *</label>    </li>
                  <li className={s.li}><input placeholder="Kg Min" className={s.input1} type="text" value={input.weight_Min} name= "weight_Min" onChange={handleChange}/></li>
                  <li className={s.li}><label>weight *</label></li>
                  <li className={s.li}><input placeholder="Kg Max"className={s.input1} type="text" value={input.weight_Max} name= "weight_Max" onChange={handleChange}/></li>
               </ul> 
            </div>
            <div>
               <label>life_span : </label>   
               <input placeholder="years of life" type="text" value={input.life_span} name= "life_span" onChange={handleChange}
               />
            </div>
            <div className={s.divf2}>
               <label> Imagen.. : </label>   
               <input placeholder="https://www.dog-image.jpg" type="text" value={input.image} name= "image" onChange={handleChange}
               />
               <p className={s.perror}>{errorMessage}</p>
            </div>
            <select className={s.sel} onChange={(e) => handleSelect(e)}>
                <option>Select</option>
                {temperaments.map((temp)=>(
                <option key={temp.id} value={temp.name}>{temp.name}</option>
                ))}                       
            </select>
            <button disabled = {errors} type="submit" className={s.btn3}>Create a Breed</button>
            </form>
            <div className={s.li2}>
            <ul>
              <li >{input.temperaments.map(el =>
                    <div className={s.li3}>
                   {el}   
                  <button className={s.btnx} 
                    onClick={()=> handleDelete(el)}> x </button></div>)}
              </li>
            </ul>
          </div>
         
          <h4 className={s.require}>* These values are required</h4>  
    </div>
    )  
}   